import Cookies from 'js-cookie'
// import secret from '@/utils/secret'

const CONSUMER_IDENTITY_KEY = 'us-key'
// console.log('CONSUMER_IDENTITY_KEY',CONSUMER_IDENTITY_KEY)
const CONSUMER_CONDITION_KEY = 'us-key'
// console.log('CONSUMER_CONDITION_KEY',CONSUMER_CONDITION_KEY)
const DO_MAIN = 'cabplink.com'
// const CONSUMER_CONDITION_KEY = 'CONSUMER_CONDITION'
//详情页目录进入阅读器自带id
const FROM_CATALOGID = 'from_catalogid'

/** 设置消费者token信息 */
export function getToken () {
  return Cookies.get(CONSUMER_IDENTITY_KEY)
}
export function setToken (token, expiresVal) {
  return expiresVal ? Cookies.set(CONSUMER_IDENTITY_KEY, token, {expires: 7, domain: DO_MAIN}) : Cookies.set(CONSUMER_IDENTITY_KEY, token, {expires: 7, domain: DO_MAIN})
}
export function removeToken () {
  // return Cookies.remove(CONSUMER_IDENTITY_KEY, {domain: DO_MAIN})
}

/** 登录状态 */
export function getConsumerCondition () {
  return Cookies.get(CONSUMER_CONDITION_KEY)
}
export function setConsumerCondition (token) {
  return Cookies.set(CONSUMER_CONDITION_KEY, token, {expires: 7, domain: DO_MAIN})
}
export function removeConsumerCondition () {
  // return Cookies.remove(CONSUMER_CONDITION_KEY, {domain: DO_MAIN})
}

/** 设置消费者状态信息 */
export function setUserToken (content) {
  Cookies.set(CONSUMER_CONDITION_KEY, content, {expires: 7, domain: DO_MAIN})
}
export function getUserToken () {
  return Cookies.get(CONSUMER_CONDITION_KEY)
}
export function removeUserToken () {
  // Cookies.remove(CONSUMER_CONDITION_KEY, {domain: DO_MAIN})
}

export function removeB () {
  return Cookies.remove(CONSUMER_CONDITION_KEY,{domain: DO_MAIN})
}

/** 来自详情页目录 */
export function getFromCatalogid () {
  return Cookies.get(FROM_CATALOGID)
}
export function setFromCatalogid (id) {
  return Cookies.set(FROM_CATALOGID, id, {expires: 7, domain: DO_MAIN})
}
export function removeFromCatalogid () {
  return Cookies.remove(FROM_CATALOGID, {domain: DO_MAIN})
}



// WEBPACK FOOTER //
// ./src/utils/cookies.js